var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "first-step-box" },
    [
      _vm.stepCopy == 1
        ? _c("div", { staticClass: "form first-form" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("p", { staticClass: "label required-fields" }, [
                _vm._v(_vm._s(_vm.$t("8000126")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value select-value",
                  class: {
                    errorClass: !!_vm.errorRulesMsg1,
                    "empty-value": !_vm.firstTemp.protocol
                  },
                  on: {
                    click: function($event) {
                      _vm.chainPopup = true
                      _vm.errorRulesMsg2 = ""
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.firstTemp.protocol
                          ? _vm.protocolDetail.protocol +
                              " " +
                              _vm.protocolDetail.upFee +
                              "ET"
                          : _vm.$t("10000009")
                      ) +
                      "\n        "
                  ),
                  _c("i", {
                    staticClass: "iconfont",
                    class: _vm.chainPopup ? "icon-shangla" : "icon-xiala"
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "error-msg-style" }, [
                _vm._v(_vm._s(_vm.errorRulesMsg1))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("p", { staticClass: "label required-fields" }, [
                  _vm._v(_vm._s(_vm.$t("8000128")))
                ]),
                _vm._v(" "),
                _c("van-field", {
                  staticClass: "value",
                  class: { errorClass: !!_vm.errorRulesMsg2 },
                  attrs: {
                    type: "textarea",
                    rows: "1",
                    autosize: "",
                    clearable: "",
                    placeholder: _vm.$t("8000138")
                  },
                  on: {
                    input: _vm.handleInput,
                    blur: _vm.handleBlur,
                    focus: _vm.handleFocus
                  },
                  model: {
                    value: _vm.firstTemp.currencyAddress,
                    callback: function($$v) {
                      _vm.$set(_vm.firstTemp, "currencyAddress", $$v)
                    },
                    expression: "firstTemp.currencyAddress"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "error-msg-style" }, [
                  _vm._v(_vm._s(_vm.errorRulesMsg2))
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stepCopy == 2
        ? _c("div", { staticClass: "confirm-information" }, [
            _c("h2", { staticClass: "bold title" }, [
              _vm._v(_vm._s(_vm.$t("8000116")))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.resultData.data.existFlag &&
                      _vm.firstTemp.protocol == "SOLANA",
                    expression:
                      "!resultData.data.existFlag && firstTemp.protocol == 'SOLANA'"
                  }
                ]
              },
              [
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("10000010")) +
                      "：" +
                      _vm._s(
                        _vm.resultData.data.totalIssueAmount == "" ||
                          _vm.resultData.data.totalIssueAmount == 0
                          ? "--"
                          : _vm.toThousands(
                              _vm.resultData.data.totalIssueAmount
                            )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000117")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyDigit || 0)
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.resultData.data.existFlag &&
                      _vm.firstTemp.protocol == "ARC20",
                    expression:
                      "!resultData.data.existFlag && firstTemp.protocol == 'ARC20'"
                  }
                ]
              },
              [
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000068")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currency || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000119")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyFull || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000117")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyDigit || 0)
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.resultData.data.existFlag &&
                      _vm.firstTemp.protocol != "SOLANA" &&
                      _vm.firstTemp.protocol != "ARC20",
                    expression:
                      "!resultData.data.existFlag && firstTemp.protocol != 'SOLANA' && firstTemp.protocol != 'ARC20'"
                  }
                ]
              },
              [
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000068")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currency || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000119")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyFull || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000117")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyDigit || 0)
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("10000010")) +
                      "：" +
                      _vm._s(
                        _vm.resultData.data.totalIssueAmount == "" ||
                          _vm.resultData.data.totalIssueAmount == 0
                          ? "--"
                          : _vm.toThousands(
                              _vm.resultData.data.totalIssueAmount
                            )
                      ) +
                      "\n      "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.resultData.data.existFlag,
                    expression: "resultData.data.existFlag"
                  }
                ]
              },
              [
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000068")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currency || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000119")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyFull || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("10000010")) +
                      "：" +
                      _vm._s(
                        _vm.resultData.data.totalIssueAmount == "" ||
                          _vm.resultData.data.totalIssueAmount == 0
                          ? "--"
                          : _vm.toThousands(
                              _vm.resultData.data.totalIssueAmount
                            )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000117")) +
                      "：" +
                      _vm._s(_vm.resultData.data.currencyDigit || 0)
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000120")) +
                      "：" +
                      _vm._s(_vm.resultData.data.priceTick || 0)
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("10000011")) +
                      "：" +
                      _vm._s(_vm.resultData.data.blockchainQuery || "--")
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "· " +
                      _vm._s(_vm.$t("8000122")) +
                      "：" +
                      _vm._s(_vm.resultData.data.content || "--")
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-buttons-box" },
        [
          _c(
            "van-button",
            { staticClass: "back-btn", on: { click: _vm.handleBack } },
            [_vm._v(_vm._s(_vm.$t("10000012")))]
          ),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "next-btn",
              attrs: {
                loading: _vm.submitButtonLoading,
                disabled: _vm.buttonDisabled
              },
              on: { click: _vm.nextStep }
            },
            [_vm._v(_vm._s(_vm.$t("10000013")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "chain-popup",
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.chainPopup,
            callback: function($$v) {
              _vm.chainPopup = $$v
            },
            expression: "chainPopup"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              title: _vm.$t("10000009"),
              "show-toolbar": "",
              "confirm-button-text": _vm.$t("300287"),
              "cancel-button-text": _vm.$t("300111"),
              columns: _vm.chainList
            },
            on: {
              confirm: _vm.onConfirm,
              cancel: function($event) {
                _vm.chainPopup = false
              }
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function(option) {
                  return [
                    _c("div", { staticClass: "custom-option" }, [
                      _vm._v(
                        _vm._s(option.protocol + " " + option.upFee + "ET")
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "msg-tip-popup",
          attrs: {
            closeable: "",
            "close-icon": "cross",
            "close-icon-position": "top-right"
          },
          model: {
            value: _vm.firstStepTipsModel,
            callback: function($$v) {
              _vm.firstStepTipsModel = $$v
            },
            expression: "firstStepTipsModel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "tip-message-box" },
            [
              _c(
                "svg",
                { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href":
                        _vm.buttonText == "8000129"
                          ? "#icon-a-Group1171274985"
                          : "#icon-tishi-1"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.errorLimitMsg))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleConfirm(_vm.buttonText)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.buttonText)))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3287f8ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3287f8ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/freeZone/createSymbol/firstStep.vue
// module id = aZz5
// module chunks = 0